"use client";

import type { ComponentProps, FC } from "react";
import { cn } from "../../utils";
import ControlIcon from "./ControlIcon";

type Props = {
  icon: ComponentProps<typeof ControlIcon>["icon"];
  label: string;
  isActive: boolean;
};

// A <span>, not a button: the whole pill is one switch, so nesting a control here would be invalid.
const ModeSelectionOption: FC<Props> = ({ icon, label, isActive }) => (
  <span
    className={cn(
      "flex h-8 items-center gap-1.5 rounded-full px-2.5",
      "text-sm font-medium whitespace-nowrap",
      "transition-colors",
      isActive ? "bg-secondary text-foreground" : "text-muted-foreground",
    )}
  >
    <ControlIcon icon={icon} />
    <span className={isActive ? "" : "max-md:hidden"}>{label}</span>
  </span>
);

export default ModeSelectionOption;
